//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class FileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Uploads a file to blob storage
     * @param targetContainer The container name to upload to
     * @param fileName (optional) Optional file name to use
     * @param folder (optional) Optional folder path within container
     * @param body The file content to upload
     * @return The FileRecord ID of the uploaded file
     */
    uploadFile(targetContainer: string, fileName: string | null | undefined, folder: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_guid> {
        let url_ = this.baseUrl + "/file/{targetContainer}/upload?";
        if (targetContainer === undefined || targetContainer === null)
            throw new globalThis.Error("The parameter 'targetContainer' must be defined.");
        url_ = url_.replace("{targetContainer}", encodeURIComponent("" + targetContainer));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (folder !== undefined && folder !== null)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<ApiResponse_guid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_guid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_guid>(null as any);
    }

    /**
     * Gets file information and a SAS URL
     * @param fileRecordId The ID of the FileRecord
     * @return Data for the file
     */
    getFileUrl(fileRecordId: string, cancelToken?: CancelToken): Promise<ApiResponse_fileUrlResponseDTO> {
        let url_ = this.baseUrl + "/file/{fileRecordId}";
        if (fileRecordId === undefined || fileRecordId === null)
            throw new globalThis.Error("The parameter 'fileRecordId' must be defined.");
        url_ = url_.replace("{fileRecordId}", encodeURIComponent("" + fileRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: AxiosResponse): Promise<ApiResponse_fileUrlResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_fileUrlResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_fileUrlResponseDTO>(null as any);
    }
}

export class SiteSurveyPublicClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Validate a survey invite token
     * @return The invite, if valid
     */
    validateSurveyToken(token: string, cancelToken?: CancelToken): Promise<ApiResponse_surveyInviteDTO> {
        let url_ = this.baseUrl + "/survey/{token}";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateSurveyToken(_response);
        });
    }

    protected processValidateSurveyToken(response: AxiosResponse): Promise<ApiResponse_surveyInviteDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_surveyInviteDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_surveyInviteDTO>(null as any);
    }

    /**
     * Submit a site survey response
     * @return Submitted
     */
    submitSiteSurvey(body: SubmitSiteSurveyRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/survey/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitSiteSurvey(_response);
        });
    }

    protected processSubmitSiteSurvey(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_string>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class SiteSurveyResponseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all SiteSurveyResponses
     * @return The list of SiteSurveyResponses
     */
    getSiteSurveyResponses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/sitesurveyresponse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSiteSurveyResponses(_response);
        });
    }

    protected processGetSiteSurveyResponses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new SiteSurveyResponse
     * @param body The SiteSurveyResponse data to create
     * @return The newly created SiteSurveyResponse data
     */
    createSiteSurveyResponse(body: SiteSurveyResponseDTO, cancelToken?: CancelToken): Promise<ApiResponse_siteSurveyResponseDTO> {
        let url_ = this.baseUrl + "/sitesurveyresponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSiteSurveyResponse(_response);
        });
    }

    protected processCreateSiteSurveyResponse(response: AxiosResponse): Promise<ApiResponse_siteSurveyResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_siteSurveyResponseDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_siteSurveyResponseDTO>(null as any);
    }

    /**
     * Retrieve a SiteSurveyResponse by ID
     * @param id The ID of the SiteSurveyResponse to retrieve
     * @return The SiteSurveyResponse data
     */
    getSiteSurveyResponseById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_siteSurveyResponseDTO> {
        let url_ = this.baseUrl + "/sitesurveyresponse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSiteSurveyResponseById(_response);
        });
    }

    protected processGetSiteSurveyResponseById(response: AxiosResponse): Promise<ApiResponse_siteSurveyResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_siteSurveyResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_siteSurveyResponseDTO>(null as any);
    }

    /**
     * Update a SiteSurveyResponse by ID
     * @param id The ID of the SiteSurveyResponse to update
     * @param body The updated SiteSurveyResponse data
     * @return The updated SiteSurveyResponse data
     */
    updateSiteSurveyResponse(id: string, body: SiteSurveyResponseDTO, cancelToken?: CancelToken): Promise<ApiResponse_siteSurveyResponseDTO> {
        let url_ = this.baseUrl + "/sitesurveyresponse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSiteSurveyResponse(_response);
        });
    }

    protected processUpdateSiteSurveyResponse(response: AxiosResponse): Promise<ApiResponse_siteSurveyResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_siteSurveyResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_siteSurveyResponseDTO>(null as any);
    }

    /**
     * Delete a SiteSurveyResponse by ID
     * @param id The ID of the SiteSurveyResponse to delete
     */
    deleteSiteSurveyResponse(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sitesurveyresponse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSiteSurveyResponse(_response);
        });
    }

    protected processDeleteSiteSurveyResponse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search SiteSurveyResponses based on criteria
     * @param body The search criteria
     * @return The search results of SiteSurveyResponses based on the criteria
     */
    searchSiteSurveyResponses(body: SearchRequestDTO_siteSurveyResponseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/sitesurveyresponse/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchSiteSurveyResponses(_response);
        });
    }

    protected processSearchSiteSurveyResponses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export SiteSurveyResponses based on search criteria
     * @param body The search criteria
     * @return The export results of SiteSurveyResponses based on the search criteria
     */
    exportSiteSurveyResponses(body: SearchRequestDTO_siteSurveyResponseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/sitesurveyresponse/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSiteSurveyResponses(_response);
        });
    }

    protected processExportSiteSurveyResponses(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class SurveyInviteClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all SurveyInvites
     * @return The list of SurveyInvites
     */
    getSurveyInvites( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/surveyinvite";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyInvites(_response);
        });
    }

    protected processGetSurveyInvites(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new SurveyInvite
     * @param body The SurveyInvite data to create
     * @return The newly created SurveyInvite data
     */
    createSurveyInvite(body: SurveyInviteDTO, cancelToken?: CancelToken): Promise<ApiResponse_surveyInviteDTO> {
        let url_ = this.baseUrl + "/surveyinvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSurveyInvite(_response);
        });
    }

    protected processCreateSurveyInvite(response: AxiosResponse): Promise<ApiResponse_surveyInviteDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_surveyInviteDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_surveyInviteDTO>(null as any);
    }

    /**
     * Retrieve a SurveyInvite by ID
     * @param id The ID of the SurveyInvite to retrieve
     * @return The SurveyInvite data
     */
    getSurveyInviteById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_surveyInviteDTO> {
        let url_ = this.baseUrl + "/surveyinvite/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyInviteById(_response);
        });
    }

    protected processGetSurveyInviteById(response: AxiosResponse): Promise<ApiResponse_surveyInviteDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_surveyInviteDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_surveyInviteDTO>(null as any);
    }

    /**
     * Update a SurveyInvite by ID
     * @param id The ID of the SurveyInvite to update
     * @param body The updated SurveyInvite data
     * @return The updated SurveyInvite data
     */
    updateSurveyInvite(id: string, body: SurveyInviteDTO, cancelToken?: CancelToken): Promise<ApiResponse_surveyInviteDTO> {
        let url_ = this.baseUrl + "/surveyinvite/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSurveyInvite(_response);
        });
    }

    protected processUpdateSurveyInvite(response: AxiosResponse): Promise<ApiResponse_surveyInviteDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_surveyInviteDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_surveyInviteDTO>(null as any);
    }

    /**
     * Delete a SurveyInvite by ID
     * @param id The ID of the SurveyInvite to delete
     */
    deleteSurveyInvite(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/surveyinvite/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSurveyInvite(_response);
        });
    }

    protected processDeleteSurveyInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search SurveyInvites based on criteria
     * @param body The search criteria
     * @return The search results of SurveyInvites based on the criteria
     */
    searchSurveyInvites(body: SearchRequestDTO_surveyInviteSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/surveyinvite/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchSurveyInvites(_response);
        });
    }

    protected processSearchSurveyInvites(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export SurveyInvites based on search criteria
     * @param body The search criteria
     * @return The export results of SurveyInvites based on the search criteria
     */
    exportSurveyInvites(body: SearchRequestDTO_surveyInviteSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/surveyinvite/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSurveyInvites(_response);
        });
    }

    protected processExportSurveyInvites(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class AuditLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve an audit log by ID
     * @param id The ID of the audit log to retrieve
     * @return The audit log data
     */
    getAuditLogById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_auditLogDTO> {
        let url_ = this.baseUrl + "/auditlogs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLogById(_response);
        });
    }

    protected processGetAuditLogById(response: AxiosResponse): Promise<ApiResponse_auditLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_auditLogDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_auditLogDTO>(null as any);
    }

    /**
     * Search audit logs based on criteria
     * @param body The search criteria
     * @return The search results of audit logs based on the criteria
     */
    searchAuditLogs(body: SearchRequestDTO_auditLogSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/auditlogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAuditLogs(_response);
        });
    }

    protected processSearchAuditLogs(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Retrieve distinct table names
     * @return The list of distinct table names
     */
    getDistinctTableNames( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/auditlogs/tablenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDistinctTableNames(_response);
        });
    }

    protected processGetDistinctTableNames(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Generates a token for user authentication
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    generateToken(body: LoginUserDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateToken(_response);
        });
    }

    protected processGenerateToken(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for user authentication via two factor authentication
     * @param body Two factor auth data for token generation
     * @return JWT token for authenticated requests
     */
    generateTokenTwoFactor(body: LoginTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/twofactor/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateTokenTwoFactor(_response);
        });
    }

    protected processGenerateTokenTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect credentials.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Refreshes an access token
     * @param body Payload containing the refresh token
     * @return The refreshed access token, refresh token, and expiration time.
     */
    refreshToken(body: RefreshTokenDTO, cancelToken?: CancelToken): Promise<ApiResponse_authDTO> {
        let url_ = this.baseUrl + "/auth/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_authDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_authDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request in case of invalid refresh token.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the refresh token is expired or invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_authDTO>(null as any);
    }

    /**
     * Setup Two-Factor Authentication
     * @param userId The ID of the user
     * @return TOTP setup details including QR code and secret
     */
    setupTwoFactor(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        let url_ = this.baseUrl + "/auth/{userId}/two-factor/setup";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupTwoFactor(_response);
        });
    }

    protected processSetupTwoFactor(response: AxiosResponse): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(null as any);
    }

    /**
     * Verify Two-Factor Authentication Code
     * @param body Payload containing the TOTP code and user ID.
     * @return Verification success message.
     */
    verifyTwoFactor(body: VerifyTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/two-factor/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyTwoFactor(_response);
        });
    }

    protected processVerifyTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request if the payload is invalid.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the TOTP code is invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Validates a Google sign in token and returns JWT token
     * @param body Google sign in token
     * @return JWT token for authenticated requests
     */
    googleTokenExchange(body: TokenExchangeDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/tokenexchange/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleTokenExchange(_response);
        });
    }

    protected processGoogleTokenExchange(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, invalid Google sign in token", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when impersonating a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogin(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogin(_response);
        });
    }

    protected processImpersonateMemberLogin(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when loggin out of a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogout(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogout(_response);
        });
    }

    protected processImpersonateMemberLogout(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class BulkEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all bulk email statuses.
     * @return List of bulk email statuses.
     */
    getAllBulkEmailStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBulkEmailStatuses(_response);
        });
    }

    protected processGetAllBulkEmailStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Process a bulk email
     * @param id The ID of the bulk email to process
     * @return The processed bulk email data
     */
    processBulkEmail(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}/process";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessBulkEmail(_response);
        });
    }

    protected processProcessBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request response if processing fails", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Server error response", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve all bulk emails
     * @return The list of bulk emails
     */
    getBulkEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmails(_response);
        });
    }

    protected processGetBulkEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new bulk email
     * @param body The bulk email data to create
     * @return The newly created bulk email data
     */
    createBulkEmail(body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkEmail(_response);
        });
    }

    protected processCreateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve a bulk email by ID
     * @param id The ID of the bulk email to retrieve
     * @return The bulk email data
     */
    getBulkEmailById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmailById(_response);
        });
    }

    protected processGetBulkEmailById(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Update a bulk email by ID
     * @param id The ID of the bulk email to update
     * @param body The updated bulk email data
     * @return The updated bulk email data
     */
    updateBulkEmail(id: string, body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBulkEmail(_response);
        });
    }

    protected processUpdateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Delete a bulk email by ID
     * @param id The ID of the bulk email to delete
     */
    deleteBulkEmail(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBulkEmail(_response);
        });
    }

    protected processDeleteBulkEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a bulk email attachment
     * @param fileName (optional) Optional file name for saving the file. If not provided, a unique name will be generated.
     * @param body The raw file content to upload
     * @return The relative path of the uploaded file
     */
    uploadBulkEmailAttachment(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/bulkemails/attachments/upload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBulkEmailAttachment(_response);
        });
    }

    protected processUploadBulkEmailAttachment(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request: Invalid file or missing parameters.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("An error occurred while uploading the file.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search bulk emails based on criteria
     * @param body The search criteria
     * @return The search results of bulk emails based on the criteria
     */
    searchBulkEmails(body: SearchRequestDTO_bulkEmailSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/bulkemails/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBulkEmails(_response);
        });
    }

    protected processSearchBulkEmails(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CommunicationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Unsubscribe an email using a token.
     * @param body Token data for unsubscribing an email.
     * @return Result of the unsubscribe action.
     */
    unsubscribeEmail(body: UnsubscribedEmailRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/communication/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeEmail(_response);
        });
    }

    protected processUnsubscribeEmail(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve all unsubscribed emails.
     * @return List of unsubscribed emails.
     */
    getAllUnsubscribedEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/unsubscribed-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUnsubscribedEmails(_response);
        });
    }

    protected processGetAllUnsubscribedEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Retrieve all communication lists.
     * @return List of communication lists.
     */
    getAllCommunicationLists( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/lists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCommunicationLists(_response);
        });
    }

    protected processGetAllCommunicationLists(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class CompanyInfoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all company infos
     * @return The list of company infos
     */
    getCompanyInfos( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfos(_response);
        });
    }

    protected processGetCompanyInfos(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new company info
     * @param body The company info data to create
     * @return The newly created data.
     */
    createCompanyInfo(body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompanyInfo(_response);
        });
    }

    protected processCreateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Retrieve a company info by ID
     * @param id The ID of the company info to retrieve
     * @return The company info data
     */
    getCompanyInfoById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfoById(_response);
        });
    }

    protected processGetCompanyInfoById(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Update a company info by ID
     * @param id The ID of the company info to update
     * @param body The updated company info data
     * @return The updated company info data.
     */
    updateCompanyInfo(id: string, body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompanyInfo(_response);
        });
    }

    protected processUpdateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Delete a company info by ID
     * @param id The ID of the company info to delete
     */
    deleteCompanyInfo(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompanyInfo(_response);
        });
    }

    protected processDeleteCompanyInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search company infos based on criteria
     * @param body The search criteria
     * @return The search results of company info based on the criteria
     */
    searchCompanyInfos(body: SearchRequestDTO_companyInfoSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/companyinfos/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompanyInfos(_response);
        });
    }

    protected processSearchCompanyInfos(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Members
     * @return The list of members
     */
    getMembers( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMembers(_response);
        });
    }

    protected processGetMembers(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Member
     * @param body The Member data to create
     * @return The newly created Member data
     */
    createMember(body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMember(_response);
        });
    }

    protected processCreateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Retrieve a Member by ID
     * @param id The ID of the Member to retrieve
     * @return The Member data
     */
    getMemberById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberById(_response);
        });
    }

    protected processGetMemberById(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Update a Member by ID
     * @param id The ID of the Member to update
     * @param body The updated Member data
     * @return The updated Member data
     */
    updateMember(id: string, body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMember(_response);
        });
    }

    protected processUpdateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Delete a Member by ID
     * @param id The ID of the Member to delete
     */
    deleteMember(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMember(_response);
        });
    }

    protected processDeleteMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Members based on criteria
     * @param body The search criteria
     * @return The search results of Members based on the criteria
     */
    searchMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/member/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMembers(_response);
        });
    }

    protected processSearchMembers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Members based on search criteria
     * @param body The search criteria
     * @return The export results of Members based on the search criteria
     */
    exportMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMembers(_response);
        });
    }

    protected processExportMembers(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Checks if an email exists.
     * @param email The email address.
     * @return Payload of ApiResponse containing Boolean
     */
    checkEmailExists(email: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/users/check-email?";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmailExists(_response);
        });
    }

    protected processCheckEmailExists(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Get a user by ID
     * @param id The ID of the user to fetch
     * @return Payload of ApiResponse containing UserDTO
     */
    getUserById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Update an existing user
     * @return Payload of ApiResponse containing UserEditDTO
     */
    updateUser(id: string, body: UserEditDTO, cancelToken?: CancelToken): Promise<ApiResponse_userEditDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ApiResponse_userEditDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userEditDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userEditDTO>(null as any);
    }

    /**
     * Deletes an existing user
     * @return Payload of ApiResponse containing String
     */
    deleteUser(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search for users
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    searchUsers(body: SearchRequestDTO_userSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/user/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Gets a list of all available permissions
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    getAllPermissions( cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/user/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Gets permissions for a specific user
     * @param userId The ID of the user whose permissions to fetch
     * @return List of user's permissions
     */
    getUserPermissions(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/user/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Create a new user
     * @return Payload of ApiResponse containing UserDTO
     */
    createUser(body: UserCreateDTO, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_userDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Generates a password reset link
     * @return Payload of ApiResponse containing String
     */
    forgotPassword(body: ForgotPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Resets a user's password using a reset token
     * @return Payload of ApiResponse containing String
     */
    resetPassword(body: ResetPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Uploads a users profile picture.
     * @param fileName (optional) The file name to use when saving the image
     * @param body The raw image file to upload
     * @return The FileRecord ID of the uploaded image
     */
    uploadProfilePicture(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_guid> {
        let url_ = this.baseUrl + "/user/upload-profile-picture?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProfilePicture(_response);
        });
    }

    protected processUploadProfilePicture(response: AxiosResponse): Promise<ApiResponse_guid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_guid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_guid>(null as any);
    }

    /**
     * Generates a SAS token for a user's profile picture.
     * @param userId The ID of the user.
     * @return The SAS URL for the profile picture.
     */
    generateProfilePictureSas(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/users/{userId}/profile-picture";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateProfilePictureSas(_response);
        });
    }

    protected processGenerateProfilePictureSas(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export interface ApiResponse_auditLogDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuditLogDTO | undefined;
}

export interface ApiResponse_authDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuthDTO | undefined;
}

export interface ApiResponse_boolean {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: boolean | undefined;
}

export interface ApiResponse_bulkEmailDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BulkEmailDTO | undefined;
}

export interface ApiResponse_companyInfoDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompanyInfoDTO | undefined;
}

export interface ApiResponse_fileUrlResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FileUrlResponseDTO | undefined;
}

export interface ApiResponse_guid {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_iEnumerable_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SiteSurveyResponseDTO[] | undefined;
}

export interface ApiResponse_list_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PermissionDTO[] | undefined;
}

export interface ApiResponse_memberDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberDTO | undefined;
}

export interface ApiResponse_searchResponseDTO_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SearchResponseDTO_siteSurveyResponseDTO | undefined;
}

export interface ApiResponse_siteSurveyResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SiteSurveyResponseDTO | undefined;
}

export interface ApiResponse_string {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_surveyInviteDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SurveyInviteDTO | undefined;
}

export interface ApiResponse_twoFactorSetupResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: TwoFactorSetupResponseDTO | undefined;
}

export interface ApiResponse_userDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserDTO | undefined;
}

export interface ApiResponse_userEditDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserEditDTO | undefined;
}

export interface AuditLogDTO {
    action?: string | undefined;
    tableName?: string | undefined;
    recordId?: string | undefined;
    propertyName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdUtc?: string | undefined;
    updatedUtc?: string | undefined;
    changedBy?: string | undefined;
}

export interface AuditLogSearchRequestDTO {
    tableName?: string | undefined;
    recordId?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export interface AuthDTO {
    accessToken?: string | undefined;
    expiresAt?: number | undefined;
    refreshToken?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
}

export interface BulkEmailDTO {
    id?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    bulkEmailStatusId?: string | undefined;
    communicationListId?: string | undefined;
    totalCount?: number | undefined;
    totalCountProcessed?: number | undefined;
    attachmentPath?: string | undefined;
    bulkEmailStatusName?: string | undefined;
    communicationListName?: string | undefined;
}

export interface BulkEmailSearchRequestDTO {
    subject?: string | undefined;
}

export interface CompanyInfoDTO {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface CompanyInfoSearchRequestDTO {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface FileUrlResponseDTO {
    url?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeInBytes?: number | undefined;
    status?: string | undefined;
}

export interface ForgotPasswordDTO {
    email: string;
}

export interface ImpersonationDTO {
    memberId?: string | undefined;
    adminId?: string | undefined;
}

export interface LoginTwoFactorDTO {
    email?: string | undefined;
    tempToken?: string | undefined;
    code?: string | undefined;
}

export interface LoginUserDTO {
    email: string;
    password: string;
}

export interface MemberDTO {
    id?: string | undefined;
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    userID?: string | undefined;
}

export interface MemberSearchRequestDTO {
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface PermissionDTO {
    name?: string | undefined;
    category?: string | undefined;
    entity?: string | undefined;
    action?: string | undefined;
}

export interface RefreshTokenDTO {
    refreshToken?: string | undefined;
}

export interface ResetPasswordDTO {
    email?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export interface SearchRequestDTO_auditLogSearchRequestDTO {
    filters?: AuditLogSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_bulkEmailSearchRequestDTO {
    filters?: BulkEmailSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_companyInfoSearchRequestDTO {
    filters?: CompanyInfoSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberSearchRequestDTO {
    filters?: MemberSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_siteSurveyResponseSearchRequestDTO {
    filters?: SiteSurveyResponseSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_surveyInviteSearchRequestDTO {
    filters?: SurveyInviteSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_userSearchRequestDTO {
    filters?: UserSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchResponseDTO_siteSurveyResponseDTO {
    results?: SiteSurveyResponseDTO[] | undefined;
    totalCount?: number | undefined;
}

export interface SiteSurveyResponseDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    submittedUtc?: Date | undefined;
    formVersion?: string | undefined;
    surveyInviteId?: string | undefined;
    phone?: string | undefined;
    usesEarthranger?: string | undefined;
    erSurvivesOutage?: string | undefined;
    erAdminContact?: string | undefined;
    alertTriggers?: string | undefined;
    alertTriggersOther?: string | undefined;
    tracksStaffPositions?: string | undefined;
    staffTrackingMethod?: string | undefined;
    droneOwnership?: string | undefined;
    droneModelDji?: string | undefined;
    droneModelOther?: string | undefined;
    launchMethod?: string | undefined;
    caaApprovals?: string | undefined;
    nightResponder?: string | undefined;
    nightResponseTime?: string | undefined;
    firstSiteInterest?: string | undefined;
}

export interface SiteSurveyResponseSearchRequestDTO {
    submittedUtc?: Date | undefined;
    formVersion?: string | undefined;
    surveyInviteId?: string | undefined;
    phone?: string | undefined;
    usesEarthranger?: string | undefined;
    erSurvivesOutage?: string | undefined;
    erAdminContact?: string | undefined;
    alertTriggers?: string | undefined;
    alertTriggersOther?: string | undefined;
    tracksStaffPositions?: string | undefined;
    staffTrackingMethod?: string | undefined;
    droneOwnership?: string | undefined;
    droneModelDji?: string | undefined;
    droneModelOther?: string | undefined;
    launchMethod?: string | undefined;
    caaApprovals?: string | undefined;
    nightResponder?: string | undefined;
    nightResponseTime?: string | undefined;
    firstSiteInterest?: string | undefined;
}

export interface SubmitSiteSurveyRequestDTO {
    token?: string | undefined;
    phone?: string | undefined;
    usesEarthranger?: string | undefined;
    erSurvivesOutage?: string | undefined;
    erAdminContact?: string | undefined;
    alertTriggers?: string[] | undefined;
    alertTriggersOther?: string | undefined;
    tracksStaffPositions?: string | undefined;
    staffTrackingMethod?: string | undefined;
    droneOwnership?: string | undefined;
    droneModelDji?: string[] | undefined;
    droneModelOther?: string | undefined;
    launchMethod?: string | undefined;
    caaApprovals?: string[] | undefined;
    nightResponder?: string[] | undefined;
    nightResponseTime?: string | undefined;
    firstSiteInterest?: string | undefined;
}

export interface SurveyInviteDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    token?: string | undefined;
    label?: string | undefined;
    isSubmitted?: boolean | undefined;
    submittedUtc?: Date | undefined;
}

export interface SurveyInviteSearchRequestDTO {
    token?: string | undefined;
    label?: string | undefined;
    isSubmitted?: boolean | undefined;
    submittedUtc?: Date | undefined;
}

export interface TokenExchangeDTO {
    token?: string | undefined;
}

export interface TwoFactorSetupResponseDTO {
    qrCodeUrl?: string | undefined;
}

export interface UnsubscribedEmailRequestDTO {
    token?: string | undefined;
    reason?: string | undefined;
}

export interface UserCreateDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureFileId?: string | undefined;
    permissions?: string[] | undefined;
}

export interface UserDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureFileId?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    permissions?: string[] | undefined;
}

export interface UserEditDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureFileId?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    permissions?: string[] | undefined;
}

export interface UserSearchRequestDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
}

export interface VerifyTwoFactorDTO {
    userId?: string | undefined;
    code?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}